var lang = {};

lang.dashboard = "Dashboard";
lang.coupons = "Licences";
lang.users = "Users";
lang.players = "Players";
lang.online_offline = "Online/Offline";
lang.online_players = "Online Players";
lang.offline_players = "Offline Players";
lang.login_google = "Sign in with Google";
lang.google = "Google";
lang.login = "Login";
lang.logout = "Logout";
lang.slogan = "Hexa Account Manager";
lang.coupon_id = "Coupon Code";
lang.provider = "Provider";
lang.email = "Email";
lang.type = "Type";
lang.registered_players = "Registered Players";
lang.subscriptions = "Subscriptions";
lang.actions = "Actions";
lang.refresh = "Refresh";
lang.clear_cache = "Clear Cache";
lang.user_details = "User Details";
lang.user_name = "Name";
lang.no_name = "no name";
lang.user_country = "Country";
lang.per_licence = "per license";
lang.licenses = "Licenses";
lang.usedLicenses = "Used Licenses";
lang.of = "of";
lang.user_no_licenses = "No. of Licenses";
lang.user_storage = "Total Storage";
lang.user_amount = "Total Amount";
lang.coupon_total_cost = "The total cost of this licence is:";
lang.upto = "Upto to";
lang.user_no_unused_licenses = "Unused Licenses";
lang.hash = "Hash";
lang.device = "Device";
lang.status = "Status";
lang.date_added = "Date Added";
lang.storage = "Storage";
lang.last_seen = "Last Seen";
lang.online = "Online";
lang.offline = "Offline";
lang.dollars = "USD";
lang.au_dollars = "AUD";
(lang.name = "Name"),
  (lang.created = "Creation Date"),
  (lang.duration = "Duration"),
  (lang.amount_off = "Amount"),
  (lang.redemptions = "Redemption Times"),
  (lang.max_redemptions = "Max Allowed");
lang.plan = "Plan";
lang.qty = "Quantity";
lang.qty_licence_coupon = "Number of Licences:";
lang.num_displays = "No. of Displays";
lang.deleteConfirm = "Confirm Delete licence";
lang.deleteMsg = "Are you sure you want to delete this licence?";
lang.deleteMsgSubUser = "Are you sure you want to delete this Sub User?";
lang.deleteConfirmSubUser = "Confirm Delete Sub User";
lang.deleteMsgUser = "Are you sure you want to delete ";
lang.refresh = "Refresh";
lang.valid = "Valid";
lang.coupon_used = "Licence is used, can not be deleted";
lang.used = "Used";
lang.yes = "Yes";
lang.no = "No";
lang.cancel = "Cancel";
lang.add_coupon = "Add Licence";
lang.assign_coupon = "Assign a License";
lang.assign_to_licence = "Assign a New License";
lang.coupon_name = "Licence Name";
lang.plan_required = "Plan is Required.";
lang.name_required = "Name is Required.";
lang.exceeded_allowed_max = "Exceed allowed max";
lang.qty_required = "No. of displays is Required.";
lang.copied = "copied to clipboard.";
lang.copy = "Copy";
lang.software = "Software";
lang.prices = "Prices";
lang.price = "Price";
lang.active = "Active";
lang.activate = "Activate";
lang.disable = "Disable";
lang.disabled = "Disabled";
lang.error = "An error has occured.";
lang.added_success = "A new licence was added successfully.";
lang.added_success_user = "A new user was added successfully.";
lang.added_coupon_success_user = "Licence was added to the user successfully.";
lang.delete_success = "Deleted successfully.";
lang.start = "Starts At";
lang.end = "Ends At";
lang.autorenew = "Auto Renew";
lang.subscription_amount = "Sub. Amount";
lang.num_players = "No. of Displays";
lang.displays = "Displays";
lang.no_subscriptions = "This account has no active subscriptions";
lang.card_details = "Card Details";
lang.close = "Close";
lang.name_on_card = "Name on Card";
lang.brand = "Brand";
lang.funding = "Type";
lang.card_number = "Card Number";
lang.expiry = "Expiry Date";
lang.password = "Password";
lang.invalid_email = "Invalid Email";
lang.invalid_password = "Invalid Password";
lang.invalid_name = "Invalid Name";
lang.no_displays = "This account has no displays added.";
lang.user_statistics = "Users Statistics";
lang.add_user = "Add User";
lang.num_users = "Number of users";
lang.users_by_country = "Number of Users By Country";
lang.players_users = "Players count per user";
lang.users_providers = "Users per provider";
lang.access_denied = "Access Denied";
lang.access_denied_msg1 =
  "You are signed in with an email that is not an administrator:";
lang.access_denied_msg2 = "Use another email";
lang.forgot_password = "Forgot Password";
lang.submit = "Submit";
lang.wrong_password =
  "The username and password you entered did not match our records. Please double-check and try again.";
lang.sub_users = "Sub Users";
lang.no_sub_users = "No Sub Users";
lang.view_details = "View Details";
lang.hide_details = "Hide Details";
lang.add_subuser = "Add Sub User";
lang.delete_subuser = "Delete Sub User";
lang.invoiced = "Invoiced";
lang.open_invoice = "Open Invoice";
lang.send_invoice = "Send Invoice";
lang.invoice_sent_success = "Invoice sent successfully";
lang.paid = "Paid";
lang.free = "Free";
lang.add_trial = "Add Trial";
lang.confirm_add_trial = "Confirm Add Trial";
lang.confirmTrialMessage = "Are you sure you want to add a Trial License?";
lang.used_by = "Used by";
lang.add_trial_success = "Trial added successfully";
lang.billing = "Billing";
lang.back = "Back";
lang.help = "Help";
lang.account_name = "Company Name";
lang.save = "Save";
lang.active_licences = "Active Licences";
lang.expired_licences = "Expired Licences";
lang.optional_note = "Optional note";
lang.coupon_note_hint =
  "Note will be added to the invoice line description (note)";
lang.pause_sub = "Pause subscription";
lang.activate_sub = "Activate subscription";
lang.pauseMsg =
  "Pausing a subscription will temporarily remove the licences from the client's account. You can unpause anytime. The subscription end date will not be affected.";
lang.pause_success = "Paused successfully.";
lang.activated_success = "Activated successfully.";
lang.paused = "Paused";
lang.account_disabled =
  "Your account has been disabled, contact your system provider";
lang.generate_password = "Generate Password";
lang.use_existing_licences = "Use an existing license";
lang.export_all = "Export all";
lang.outstanding_invoices = "Outstanding Invoices";
lang.open_billing = "Open Billing Page";
export { lang };
